import React, { Component } from 'react';
import { FormattedText } from 'core/i18n';

class CreditCardLimitCredit extends Component {
    render() {
        const { limit } = this.props;
        return (
            <div className="open-credit-sale__limit-container">
                <div className="open-credit-sale__text">
                    <FormattedText value="creditCardOffer-limit" injectedStrings={[limit]} />
                </div>
            </div>
        );
    }
}

export default CreditCardLimitCredit;
